import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import { Link } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import { CreateQuestionTypeData } from "../../services/QuestionsService";
import { toast } from "react-toastify";
import { checkPermissionStatus } from "helpers/utils";

import arrow_btn from "../../assets/images/icon/arrow-btn.svg";

function CreateQuestionType() {
  const [formDataValues, setFormDataValues] = useState({});
  const [errors, setErrors] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [status, setStatus] = useState([
    { label: "Active", value: "1", id: "1" },
    { label: "Inactive", value: "0", id: "0" },
  ]);

  /* State Field selected value */
  const handleChangeStatusValuePopulate = e => {
    setFormDataValues(prevState => ({
      ...prevState,
      status: e?.id,
    }));
  };

  /* Handle Change Event */
  const handleChange = e => {
    const { name, value } = e.target;
    setFormDataValues({
      ...formDataValues,
      [name]: value,
    });
  };

  // Validation logic for each field
  const validateForm = () => {
    let isValid = true;
    const newErrors = {};

    if (!formDataValues.ques_type) {
      newErrors.ques_type = "Please select an option";
      isValid = false;
    }
    if (!formDataValues.status) {
      newErrors.status = "Please select an option";
      isValid = false;
    }
    setErrors(newErrors);
    return isValid;
  };

  // Submit the form data or perform other actions
  const handleSubmit = async e => {
    if (validateForm()) {
      let formData = new FormData();

      formData.append("ques_type", e?.ques_type);
      formData.append("status", e?.status);
      let fromEntriesObj = Object.fromEntries(formData);

      CreateQuestionTypeData(fromEntriesObj)
        .then(res => {
          if (res?.status === 200) {
            let messages = toast.success(res?.data?.message);
            window.location.href = "/question-type-list";
          } else {
            let messages = toast.error(res?.data?.message);
          }
        })
        .catch(err => {
          console.error("Error fetching department list:", err);
          setErrors("No data created.");
        });
    } else {
      console.error("Form has errors");
    }
  };

  if (!checkPermissionStatus("question-type-list", "create")) {
    return (
      <div className="page-content">
        <h4 className="text-center">Access Denied.</h4>
      </div>
    );
  }
  return (
    <React.Fragment>
      <div className="page-content">
        {/* <MetaTags><title>Create Question Type</title></MetaTags> */}

        <div className="joblist-container create-vacancy">
          <Row className="mb-3 align-items-center py-2 pt-0">
            <Col lg="6" md="6">
              <Link to="/question-type-list">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  Create Question Type
                </h5>
              </Link>
            </Col>
            {/* <Col lg="6" md="6">
            <div className="single-filter-box btn-left d-flex justify-content-end align-items-center gap-2">
              <Link to="/employee-referral-list" className="btn btn-primary">
                Back To Listing
              </Link>
            </div>
          </Col> */}
          </Row>
        </div>

        <div className="outerTab-box-wrapper below-vacancy">
          <div className="form-details-section mt-2">
            <Container fluid>
              <Col lg="12">
                <AvForm
                  className="outer-repeater"
                  onValidSubmit={() => {
                    handleSubmit(formDataValues);
                  }}
                >
                  <div data-repeater-list="outer-group" className="outer">
                    <div data-repeater-item className="outer">
                      {successMessage && (
                        <div class="alert alert-success" role="alert">
                          {successMessage}
                        </div>
                      )}
                      {errorMessage && (
                        <div class="alert alert-danger" role="alert">
                          {errorMessage}
                        </div>
                      )}

                      <Row>
                        <Col lg="6">
                          <FormGroup className="mb-2" row>
                            <Label
                              htmlFor="ques_type"
                              className="col-form-label"
                            >
                              Question Type
                              <span className="text-danger">*</span>
                            </Label>
                            <AvField
                              type="text"
                              className="form-control"
                              id="ques_type"
                              name="ques_type"
                              placeholder="Question Type"
                              errorMessage="Question Type Required."
                              validate={{
                                required: {
                                  value: true,
                                  errorMessage: "Question Type is required",
                                },
                                minLength: {
                                  value: 2,
                                  errorMessage:
                                    "Question Type must be at least 2 characters",
                                },
                                maxLength: {
                                  value: 50,
                                  errorMessage:
                                    "Question Type cannot exceed 50 characters",
                                },
                              }}
                              value={formDataValues?.ques_type || ""}
                              onChange={handleChange}
                            />
                            <div className="error">{errors.ques_type}</div>
                          </FormGroup>
                        </Col>

                        <Col lg="6">
                          <FormGroup className="mb-2" row>
                            <Label className="col-form-label">
                              Status<span className="text-danger">*</span>{" "}
                            </Label>
                            <Select
                              className="mb-2"
                              placeholder="Select Status"
                              id="status_id"
                              name="status"
                              validate={{ required: { value: true } }}
                              options={status}
                              onChange={e => handleChangeStatusValuePopulate(e)}
                            />
                            <div className="error">{errors.status}</div>
                          </FormGroup>
                        </Col>

                        <div className="cta text-center gap-2 d-flex justify-content-center mt-4 mb-2">
                          <Button
                            type="button"
                            className="btn btn-secondary"
                            onClick={e => {
                              e.preventDefault();
                              window.location.href = "/question-type-list";
                            }}
                          >
                            {" "}
                            Cancel
                          </Button>
                          <Button
                            type="submit"
                            color="success"
                            className="btn btn-primary"
                          >
                            Submit
                          </Button>
                        </div>
                      </Row>
                    </div>
                  </div>
                </AvForm>
              </Col>
            </Container>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default CreateQuestionType;
